import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import myPawn from '@/view/myPawn'   // 我要典当
import channel from '@/view/channel'   // 渠道合作
import walkInto from '@/view/walkInto'   // 走进联丰
import hire from '@/view/hire'   // 人才招聘
import pawnProducts from '@/view/pawnProducts'   // 典当产品
import answer from '@/view/answer'   // 问答
import gold from '@/view/gold'   // 今日金价
import moblieHome from '@/view/moblieHome'   // 手机端H5

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
		{
		    path: '/myPawn',  //我要典当
		    name: 'myPawn',
		    component: myPawn,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/channel',  //渠道合作
		    name: 'channel',
		    component: channel,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/walkInto',  //走进联丰
		    name: 'walkInto',
		    component: walkInto,
		    props: route => ({ query: route.query.q }),
		},
		{
		    path: '/hire',  //人才招聘
		    name: 'hire',
		    component: hire,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/pawnProducts',  //典当产品
		    name: 'pawnProducts',
		    component: pawnProducts,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/answer',  //问答
		    name: 'answer',
		    component: answer,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/gold',  //今日金价
		    name: 'gold',
		    component: gold,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/moblieHome',  //手机端H5
		    name: 'moblieHome',
		    component: moblieHome,
		    props: route => ({ query: route.query.q })
		},
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js